export const datePickerStyles = {
  label: "text-sm font-medium text-gray-800 dark:text-white/90 mb-1 block",
  flatpickrWrapper: "relative w-full",
  flatpickrInput:
  "h-11 w-full rounded-lg border appearance-none px-4 py-2.5 text-sm shadow-theme-xs placeholder:text-gray-800 focus:outline-none focus:ring dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/90 bg-transparent text-gray-800 border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring-brand-500/10 cursor-pointer",

  flatpickrDefault:
    "border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring-brand-500/10",
  inputError:
    "border-red-400 ring-2 ring-red-500/10 dark:border-red-400 dark:ring-2 dark:ring-red-500/10",
  flatpickrIcon: "absolute text-gray-400 -translate-y-1/2 pointer-events-none right-3 top-1/2 dark:text-gray-400",
  errorText: "text-red-500 dark:text-red-400 text-xs mt-1",
  required: "text-error-500 dark:text-red-400",
};
